import React from "react";
import { View, Text, StyleSheet } from "react-native";
import { colors, radii, spacing, typographyScale } from "../../../../styles/design-system";
import AxioCard from "../../../axio-ds/Card/AxioCard";
import type { TriageStats } from "../SafetySupportScreen";

interface StatsCardsProps {
  stats: TriageStats;
}

export function StatsCards({ stats }: StatsCardsProps) {
  const hasCritical = stats.critical > 0;

  return (
    <View style={styles.container}>
      {/* Open Items */}
      <AxioCard style={styles.card}>
        <Text style={styles.value}>{stats.total}</Text>
        <Text style={styles.label}>Open Items</Text>
      </AxioCard>

      {/* Critical */}
      <AxioCard style={[styles.card, hasCritical && styles.cardCritical]}>
        <Text style={[styles.value, hasCritical && styles.valueCritical]}>{stats.critical}</Text>
        <Text style={[styles.label, hasCritical && styles.labelCritical]}>Critical</Text>
      </AxioCard>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: spacing.sm,
    marginBottom: spacing.lg,
  },
  card: {
    flex: 1,
    minWidth: 140,
    borderRadius: radii.xl,
    padding: spacing.sm,
    height: 87,
    alignItems: "flex-start",
    justifyContent: "center",
  },
  cardCritical: {
    backgroundColor: colors.error[50],
  },
  value: {
    fontSize: typographyScale.displaySm.fontSize,
    lineHeight: typographyScale.displaySm.lineHeight,
    fontWeight: "700",
    color: colors.grey[900],
    marginBottom: spacing.xxs,
  },
  valueCritical: {
    color: colors.error[700],
  },
  label: {
    fontSize: typographyScale.textSm.fontSize,
    lineHeight: typographyScale.textSm.lineHeight,
    color: colors.grey[500],
  },
  labelCritical: {
    color: colors.error[600],
  },
});
